import { render, staticRenderFns } from "./regenerate.vue?vue&type=template&id=0a115b83"
import script from "./regenerate.vue?vue&type=script&lang=js"
export * from "./regenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports